import React, { useState, useEffect } from "react";
import * as SurveyJS from "survey-react";
import { disableMultiDropdownList } from "../../../utilities/surveyConfig";
import "survey-core/survey.i18n";
import "survey-react/defaultV2.css";
import { StylesManager } from "survey-react";
import "./surveyJS.css";
import MarkdownIt from "markdown-it";
import attrs from "markdown-it-attrs";
import FileDownload from "../../fileUpload/FileDownload";


StylesManager.applyTheme("defaultV2");

// register custom fiel upload question
SurveyJS.ComponentCollection.Instance.add({
  name: "file-upload",
  title: "file-upload"
},
);

// register custom file upload widget to survey
SurveyJS.CustomWidgetCollection.Instance.addCustomWidget({
  name: 'file-upload',
  isFit: question => {
    return question.getType() == "file-upload";
  },
  render: question => {      
   if(question.value !== undefined && question.value !== null)
    return <FileDownload  attachedFiles={ question } />
    else
    return <label htmlFor="no-files">No files are attached.</label>  
  }
})

function updateStringComponents(_, options) {
  const questionVal = options.question.value;
  const questionType = options.question.getType();
  
  // Only add links for text questions that contain URLs
  if (isValidUrl(questionVal) && questionType === "text") {
    const div = document.createElement("div");
    div.className = "sd_customLink";
    
    // Check if we're in display mode (viewing responses) vs edit mode
    if (options.question.survey?.mode === "display") { 
      // In display mode, show URL as non-clickable text
      div.innerHTML = questionVal;
    } else {
      // In edit mode, show as clickable link with the actual URL as text
      div.innerHTML = "<a href='" + questionVal + "' target='_blank' data-interception='off'>" + questionVal + "</a>";
    }
    
    div.className = "sd_customLink";
    
    // Check if we're in display mode (viewing responses) vs edit mode
    if (options.question.survey?.mode === "display") {
      // In display mode, show URL as non-clickable text
      div.innerHTML = questionVal;
    } else {
      // In edit mode, show as clickable link with the actual URL as text
      div.innerHTML = "<a href='" + questionVal + "' target='_blank' data-interception='off'>" + questionVal + "</a>";
    }
    
    options.htmlElement.appendChild(div);
  }
}

const isValidUrl = urlString => {
  var inputElement = document.createElement('input');
  inputElement.type = 'url';
  inputElement.value = urlString;

  if (!inputElement.checkValidity()) {
    return false;
  } else {
    return true;
  }
}

export function KitchensinkSurvey({
  template,
  allowSaveProgress,
  onSaveProgress,
  mode,
  onComplete,
  data,
  ...props
}) {
  // Disable the multi dropdown list feature added in SurveyJS 1.9.114
  disableMultiDropdownList();
  
  const [surveyModel] = useState(new SurveyJS.SurveyModel(template));
  const markdownConverter = new MarkdownIt();
  markdownConverter.use(attrs, {
    allowedAttributes: ["target"],
  });

  useEffect(() => {
    if (!!data) {
      // fix #105058
      surveyModel.data = data;
      surveyModel.currentPageNo = 0; // force surveyJS to recalculate expressions see: https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#data
    }
  }, []);

  // language selection
  const [language] = useState("en");

  surveyModel.locale = language;
  surveyModel.onAfterRenderQuestion.add(updateStringComponents);
  if (!!data) {
    surveyModel.data = data;
  }
  function onTextMarkdown(survey, options) {
    if (options.name !== "title") {
      options.html = markdownConverter.renderInline(options.text);
    }
  }

  return (
    <>
      <SurveyJS.Survey
        model={surveyModel}
        mode={mode}
        onTextMarkdown={onTextMarkdown}
        {...props}
      />
    </>
  );
}
